import Schema from 'async-validator';

function isEmptyValue(value, type) {
    if (value === undefined || value === null) {
        return true;
    }
    if (type === 'array' && Array.isArray(value) && !value.length) {
        return true;
    }
    if (isNativeStringType(type) && typeof value === 'string' && !value) {
        return true;
    }
    return false;
}

function isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

// #region phone

// 提供默认的错误提示信息
Schema.messages['epoint_phone'] = '%s 不是有效的电话号码';

// 注册新的 type 并实现验证方法
Schema.register(
    'epoint_phone',
    /**
     *  扩展： 验证是否有效的电话号码
     *
     *  @param rule The validation rule.
     *  @param value The value of the field on the source object.
     *  @param callback The callback function. 参数为错误数组
     *  @param source The source object being validated.
     *  @param options The validation options.
     *  @param options.messages The validation messages. 等同 Schema.messages
     */
    function (rule, value, callback, source, options) {
        const errors = [];
        /*eslint no-prototype-builtins: "off"*/
        const validate = rule.required || (!rule.required && source.hasOwnProperty(rule.field));

        if (validate) {
            // 空 且不是必填 结束
            if (isEmptyValue(value) && !rule.required) {
                return callback();
            }

            // 必填处理
            if (rule.required && isEmptyValue(value)) {
                errors.push(new Error(options.messages['epoint_phone'].replace(/%s/, rule.fullField || rule.field)));
            }

            // 校验
            const isOk = /^1[3456789]\d{9}$/.test(value) || /^0\d{2}-\d{8}$/.test(value) || /^0\d{3}-\d{7,8}$/.test(value) || /^\d{7,8}$/.test(value);
            if (!isOk) {
                const msg = rule.messages || options.messages['epoint_phone'];
                const message = msg.replace(/%s/, value);
                errors.push(new Error(message));
            }
        }
        callback(errors);
    }
);
// #endregion

// #region idcard
// 提供默认的错误提示信息
Schema.messages['epoint_idcard'] = '请输入有效的身份证号码';

// 注册新的 type 并实现验证方法
Schema.register('epoint_idcard', function (rule, value, callback, source, options) {
    const errors = [];
    /*eslint no-prototype-builtins: "off"*/
    const validate = rule.required || (!rule.required && source.hasOwnProperty(rule.field));

    if (validate) {
        // 空 且不是必填 结束
        if (isEmptyValue(value) && !rule.required) {
            return callback();
        }

        // 必填处理
        if (rule.required && isEmptyValue(value)) {
            errors.push(new Error(options.messages['epoint_idcard'].replace(/%s/, rule.fullField || rule.field)));
        }

        // 校验
        const isOk = validateIdCard(value);
        if (!isOk) {
            const msg = rule.messages || options.messages['epoint_idcard'];
            const message = msg.replace(/%s/, value);
            errors.push(new Error(message));
        }
    }
    callback(errors);
});

function validateIdCard(idCard) {
    // 15位和18位身份证号码的正则表达式 view at https://fe.epoint.com.cn/regexp/#%2F%5E%28%5E%5B1-9%5D%5Cd%7B7%7D%28%280%5Cd%29%7C%281%5B0-2%5D%29%29%28%28%5B0%7C1%7C2%5D%5Cd%29%7C3%5B0-1%5D%29%5Cd%7B3%7D%24%29%7C%28%5E%5B1-9%5D%5Cd%7B5%7D%5B1-9%5D%5Cd%7B3%7D%28%280%5Cd%29%7C%281%5B0-2%5D%29%29%28%28%5B0%7C1%7C2%5D%5Cd%29%7C3%5B0-1%5D%29%28%28%5Cd%7B4%7D%29%7C%5Cd%7B3%7D%5BXx%5D%29%24%29%24%2F
    let regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

    // 如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            let idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); // 将前17位加权因子保存在数组里
            let idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
            let idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
            for (let i = 0; i < 17; i++) {
                idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }

            let idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
            let idCardLast = idCard.substring(17); // 得到最后一位身份证号码

            // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                if (idCardLast == 'X' || idCardLast == 'x') {
                    return true;
                } else {
                    return false;
                }
            } else {
                // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                if (idCardLast == idCardY[idCardMod]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    } else {
        return false;
    }
}

// #endregion

// #region password

// 提供默认的错误提示信息
Schema.messages['epoint_password'] = '请输入5-20位数字、英文';

// 注册新的 type 并实现验证方法
Schema.register(
    'epoint_password',
    /**
     *  扩展： 验证是否有效的电话号码
     *
     *  @param rule The validation rule.
     *  @param value The value of the field on the source object.
     *  @param callback The callback function. 参数为错误数组
     *  @param source The source object being validated.
     *  @param options The validation options.
     *  @param options.messages The validation messages. 等同 Schema.messages
     */
    function (rule, value, callback, source, options) {
        const errors = [];
        /*eslint no-prototype-builtins: "off"*/
        const validate = rule.required || (!rule.required && source.hasOwnProperty(rule.field));

        if (validate) {
            // 空 且不是必填 结束
            if (isEmptyValue(value) && !rule.required) {
                return callback();
            }

            // 必填处理
            if (rule.required && isEmptyValue(value)) {
                errors.push(new Error(options.messages['epoint_password'].replace(/%s/, rule.fullField || rule.field)));
            }

            // 校验
            const isOk = /^[0-9a-zA-Z]{5,20}$/.test(value);
            if (!isOk) {
                const msg = rule.messages || options.messages['epoint_password'];
                const message = msg.replace(/%s/, value);
                errors.push(new Error(message));
            }
        }
        callback(errors);
    }
);
// #endregion
